var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCameraLive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "9px",
    viewBox: "0 0 13 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCameraLive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7169942,0.26006507 C12.6541322,0.23666907 12.5936841,0.22492181 12.535599,0.22492181 C12.4049966,0.22492181 12.2962967,0.26954661 12.2091691,0.35854994 L9.28560539,3.18518144 L9.28560539,2.02503509 C9.28560539,1.46715119 9.08126592,0.99026671 8.67258697,0.5941354 C8.26388262,0.19805334 7.77191285,0 7.19627113,0 L2.08923263,0 C1.51376877,0 1.02164654,0.19805334 0.612916781,0.5941354 C0.204339473,0.99026671 0,1.46715119 0,2.02503509 L0,6.9750388 C0,7.5328734 0.204339473,8.0097333 0.612942191,8.40584 C1.02167195,8.8019467 1.51379418,9 2.08925804,9 L7.19632194,9 C7.77193826,9 8.26393344,8.8019467 8.67263779,8.40584 C9.08131674,8.0097333 9.28565621,7.5328981 9.28565621,6.9750388 L9.28565621,5.80777514 L12.20922,8.6414254 C12.2963475,8.7304041 12.4050474,8.7750043 12.5356499,8.7750043 C12.5937349,8.7750043 12.654183,8.7632817 12.717045,8.7399349 C12.9057579,8.6602161 13,8.5219827 13,8.3251114 L13,0.6750117 C13,0.47804196 12.9056817,0.33978388 12.7169942,0.26006507 Z",
    id: "icCameraLive",
    fill: "#E83838",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCameraLive);
export default __webpack_public_path__ + "static/media/icCameraLive.1f3085e8efd48b37f600c2bcb19ffbca.svg";
export { ForwardRef as ReactComponent };